(function () {
  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }

    return (cents / 100).toLocaleString('tr-TR', {
      style: 'currency',
      currency: 'TRY'
    });
  }

  function initHero(root) {
    var mainImage = root.querySelector('[data-iyi-hero-main-image]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-iyi-hero-thumb]'));
    var prev = root.querySelector('[data-iyi-hero-prev]');
    var next = root.querySelector('[data-iyi-hero-next]');
    var selectedIndex = 0;
    var touchStartX = 0;
    var touchStartY = 0;

    function show(index) {
      if (!mainImage || !thumbs.length) return;
      selectedIndex = (index + thumbs.length) % thumbs.length;
      var thumb = thumbs[selectedIndex];
      mainImage.src = thumb.getAttribute('data-image');
      mainImage.alt = thumb.getAttribute('data-alt') || '';
      thumbs.forEach(function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-selected', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-selected', 'true');
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        show(index);
      });
    });

    if (prev) prev.addEventListener('click', function () { show(selectedIndex - 1); });
    if (next) next.addEventListener('click', function () { show(selectedIndex + 1); });

    if (mainImage && thumbs.length > 1) {
      mainImage.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });

      mainImage.addEventListener('touchend', function (event) {
        if (!event.changedTouches || !event.changedTouches.length) return;
        var deltaX = event.changedTouches[0].clientX - touchStartX;
        var deltaY = event.changedTouches[0].clientY - touchStartY;

        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        show(deltaX < 0 ? selectedIndex + 1 : selectedIndex - 1);
      }, { passive: true });
    }
  }

  function initVariantPricing(root) {
    var select = root.querySelector('[data-iyi-variant-select]');
    var variantsNode = root.querySelector('[data-iyi-variants-json]');
    var price = root.querySelector('[data-iyi-price]');
    var compare = root.querySelector('[data-iyi-compare-price]');
    var button = root.querySelector('[data-iyi-atc]');
    if (!select || !variantsNode) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      variants = [];
    }

    select.addEventListener('change', function () {
      updateFromSelect();
    });

    function updateFromSelect() {
      var variant = variants.find(function (item) {
        return String(item.id) === String(select.value);
      });

      if (!variant) return;

      var format = root.getAttribute('data-money-format') || '{{amount}}';
      if (price) price.textContent = formatMoney(variant.price, format);
      if (compare) {
        compare.textContent = variant.compare_at_price && variant.compare_at_price > variant.price
          ? formatMoney(variant.compare_at_price, format)
          : '';
      }
      if (button) button.disabled = !variant.available;
      root.querySelectorAll('[data-iyi-variant-id-input]').forEach(function (input) {
        input.value = variant.id;
      });
    }
  }

  function normalizeText(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function findMatchingVariantOption(select, packageTitle, packageIndex) {
    if (!select || !packageTitle) return null;
    var normalizedTitle = normalizeText(packageTitle);
    var compactTitle = normalizedTitle.replace(/\s+/g, '');
    var options = Array.prototype.slice.call(select.options);

    var textMatch = options.find(function (option) {
      var optionText = normalizeText(option.textContent);
      var compactOption = optionText.replace(/\s+/g, '');
      return optionText.indexOf(normalizedTitle) !== -1 || compactOption.indexOf(compactTitle) !== -1;
    });

    var index = Number(packageIndex);
    if (textMatch && !textMatch.disabled) return textMatch;
    if (Number.isInteger(index) && options[index]) return options[index];
    if (textMatch) return textMatch;

    return null;
  }

  function parseVariants(root) {
    var variantsNode = root.querySelector('[data-iyi-variants-json]');
    if (!variantsNode) return [];

    try {
      return JSON.parse(variantsNode.textContent);
    } catch (error) {
      return [];
    }
  }

  function updateVisibleVariantState(root, variant) {
    if (!variant) return;

    var price = root.querySelector('[data-iyi-price]');
    var compare = root.querySelector('[data-iyi-compare-price]');
    var button = root.querySelector('[data-iyi-atc]');
    var format = root.getAttribute('data-money-format') || '{{amount}}';

    if (price) price.textContent = formatMoney(variant.price, format);
    if (compare) {
      compare.textContent = variant.compare_at_price && variant.compare_at_price > variant.price
        ? formatMoney(variant.compare_at_price, format)
        : '';
    }
    if (button) button.disabled = !variant.available;
  }

  function updateVisiblePackageState(root, card) {
    if (!card) return;

    var priceValue = parseInt(card.getAttribute('data-package-price'), 10);
    var compareValue = parseInt(card.getAttribute('data-package-compare-price'), 10);
    var price = root.querySelector('[data-iyi-price]');
    var compare = root.querySelector('[data-iyi-compare-price]');
    var format = root.getAttribute('data-money-format') || '{{amount}}';

    if (Number.isFinite(priceValue) && price) {
      price.textContent = formatMoney(priceValue, format);
    }

    if (compare) {
      compare.textContent = Number.isFinite(compareValue) && compareValue > priceValue
        ? formatMoney(compareValue, format)
        : '';
    }
  }

  function setRootVariant(root, variantId) {
    if (!variantId) return;

    var idInputs = Array.prototype.slice.call(root.querySelectorAll('[data-iyi-variant-id-input]'));
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-iyi-variant-select]'));
    var variants = parseVariants(root);
    var variant = variants.find(function (item) {
      return String(item.id) === String(variantId);
    });

    idInputs.forEach(function (input) {
      input.value = variantId;
    });

    selects.forEach(function (select) {
      var option = Array.prototype.slice.call(select.options).find(function (item) {
        return String(item.value) === String(variantId);
      });
      if (option) {
        select.value = variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    updateVisibleVariantState(root, variant);
  }

  function setRootQuantity(root, quantity) {
    var parsed = parseInt(quantity, 10);
    if (!Number.isFinite(parsed) || parsed < 1) parsed = 1;

    root.querySelectorAll('[data-iyi-quantity-input]').forEach(function (input) {
      input.value = String(parsed);
    });
  }

  function initPackageOptions(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-iyi-package-option]'));
    if (!cards.length) return;

    var select = root.querySelector('[data-iyi-variant-select]');

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (item) {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });

        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');

        var variantId = card.getAttribute('data-variant-id');
        var matchingOption = findMatchingVariantOption(
          select,
          card.getAttribute('data-package-title'),
          card.getAttribute('data-package-index')
        );

        if (!variantId && matchingOption && !matchingOption.disabled) {
          variantId = matchingOption.value;
        }

        if (variantId) {
          setRootVariant(root, variantId);
        }

        setRootQuantity(root, card.getAttribute('data-package-quantity'));
        updateVisiblePackageState(root, card);
      });
    });

    root.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var selectedCard = root.querySelector('[data-iyi-package-option].is-selected');
        if (selectedCard) {
          if (selectedCard.getAttribute('data-variant-id')) {
            setRootVariant(root, selectedCard.getAttribute('data-variant-id'));
          }
          setRootQuantity(root, selectedCard.getAttribute('data-package-quantity'));
          updateVisiblePackageState(root, selectedCard);
        }
      });
    });
  }

  function initInfoTabs(scope) {
    var roots = Array.prototype.slice.call(scope.querySelectorAll('[data-iyi-tabs]'));

    roots.forEach(function (tabsRoot) {
      var buttons = Array.prototype.slice.call(tabsRoot.querySelectorAll('[data-iyi-tab-button]'));
      var panels = Array.prototype.slice.call(tabsRoot.querySelectorAll('[data-iyi-tab-panel]'));
      var jumpButtons = Array.prototype.slice.call(tabsRoot.querySelectorAll('[data-iyi-tab-jump]'));

      function activateTab(tabId, shouldScroll) {
        var activeButton = buttons.find(function (item) {
          return item.getAttribute('data-iyi-tab-button') === tabId;
        });

        buttons.forEach(function (item) {
          var isActive = item === activeButton;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-iyi-tab-panel') === tabId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        if (shouldScroll) {
          var activePanel = panels.find(function (panel) {
            return panel.getAttribute('data-iyi-tab-panel') === tabId;
          });
          if (activePanel) activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          activateTab(button.getAttribute('data-iyi-tab-button'), false);
        });
      });

      jumpButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          activateTab(button.getAttribute('data-iyi-tab-jump'), true);
        });
      });
    });
  }

  function initResearchTabs(scope) {
    var roots = Array.prototype.slice.call(scope.querySelectorAll('[data-iyi-research-tabs]'));

    roots.forEach(function (researchRoot) {
      var buttons = Array.prototype.slice.call(researchRoot.querySelectorAll('[data-iyi-research-tab]'));
      var items = Array.prototype.slice.call(researchRoot.querySelectorAll('[data-iyi-research-item]'));

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var tabId = button.getAttribute('data-iyi-research-tab');

          buttons.forEach(function (item) {
            var isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          items.forEach(function (item) {
            item.classList.toggle('is-hidden', item.getAttribute('data-iyi-research-item') !== tabId);
          });
        });
      });
    });
  }

  function initUxTabs(scope) {
    var roots = Array.prototype.slice.call(scope.querySelectorAll('[data-iyi-ux-tabs]'));

    roots.forEach(function (uxRoot) {
      if (uxRoot.getAttribute('data-iyi-ux-ready') === 'true') return;
      uxRoot.setAttribute('data-iyi-ux-ready', 'true');

      var buttons = Array.prototype.slice.call(uxRoot.querySelectorAll('[data-iyi-ux-filter]'));
      var cards = Array.prototype.slice.call(uxRoot.querySelectorAll('[data-iyi-ux-card]'));
      var track = uxRoot.querySelector('.iyi-user-experience-media__grid');
      var openButtons = Array.prototype.slice.call(uxRoot.querySelectorAll('[data-iyi-ux-open]'));
      var modal = uxRoot.querySelector('[data-iyi-ux-modal]');
      var modalTrack = uxRoot.querySelector('[data-iyi-ux-modal-track]');
      var closeButton = uxRoot.querySelector('[data-iyi-ux-close]');
      var prevButton = uxRoot.querySelector('[data-iyi-ux-prev]');
      var nextButton = uxRoot.querySelector('[data-iyi-ux-next]');
      var hint = uxRoot.querySelector('[data-iyi-ux-hint]');
      var scrollTimer = null;
      var hintTimer = null;
      var touchStartX = 0;
      var touchStartY = 0;
      var isHorizontalSwipe = false;
      var modalHistoryActive = false;

      function showHint() {
        if (!hint) return;
        window.clearTimeout(hintTimer);
        hint.classList.add('is-visible');
        hintTimer = window.setTimeout(function () {
          hint.classList.remove('is-visible');
        }, 2600);
      }

      function pauseModalVideos() {
        if (!modal) return;
        modal.querySelectorAll('video').forEach(function (video) {
          video.pause();
        });
      }

      function playNearestVideo() {
        if (!modalTrack || !modal || modal.hidden) return;
        var slides = Array.prototype.slice.call(modalTrack.querySelectorAll('[data-iyi-ux-slide]'));
        var nearest = slides.reduce(function (closest, slide) {
          var distance = Math.abs(slide.offsetTop - modalTrack.scrollTop);
          if (!closest || distance < closest.distance) return { slide: slide, distance: distance };
          return closest;
        }, null);

        pauseModalVideos();
        if (nearest && nearest.slide) {
          var video = nearest.slide.querySelector('video');
          if (video) video.play().catch(function () {});
        }
      }

      function getCurrentSlideIndex() {
        if (!modalTrack) return 0;
        var slides = Array.prototype.slice.call(modalTrack.querySelectorAll('[data-iyi-ux-slide]'));
        var nearest = slides.reduce(function (closest, slide, index) {
          var distance = Math.abs(slide.offsetTop - modalTrack.scrollTop);
          if (!closest || distance < closest.distance) return { index: index, distance: distance };
          return closest;
        }, null);

        return nearest ? nearest.index : 0;
      }

      function goToModalSlide(direction) {
        if (!modalTrack) return;
        var slides = Array.prototype.slice.call(modalTrack.querySelectorAll('[data-iyi-ux-slide]'));
        if (!slides.length) return;
        var currentIndex = getCurrentSlideIndex();
        var nextIndex = Math.max(0, Math.min(slides.length - 1, currentIndex + direction));
        modalTrack.scrollTo({ top: slides[nextIndex].offsetTop, behavior: 'smooth' });
      }

      function openModal(index) {
        if (!modal || !modalTrack) return;
        if (!modalHistoryActive && window.history && window.history.pushState) {
          window.history.pushState({ iyiUxModal: true }, '');
          modalHistoryActive = true;
        }
        modal.hidden = false;
        document.body.classList.add('iyi-ux-modal-open');
        showHint();

        window.requestAnimationFrame(function () {
          var slide = modalTrack.querySelector('[data-iyi-ux-slide="' + index + '"]');
          if (slide) modalTrack.scrollTo({ top: slide.offsetTop, behavior: 'auto' });
          playNearestVideo();
        });
      }

      function closeModal(fromHistory) {
        if (!modal) return;
        if (modal.hidden) {
          modalHistoryActive = false;
          return;
        }
        if (hint) hint.classList.remove('is-visible');
        pauseModalVideos();
        modal.hidden = true;
        document.body.classList.remove('iyi-ux-modal-open');

        if (modalHistoryActive) {
          modalHistoryActive = false;
          if (!fromHistory && window.history && window.history.state && window.history.state.iyiUxModal) {
            window.history.back();
          }
        }
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var filter = button.getAttribute('data-iyi-ux-filter') || 'all';

          buttons.forEach(function (item) {
            var isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          cards.forEach(function (card) {
            var type = card.getAttribute('data-iyi-ux-type');
            card.classList.toggle('is-hidden', filter !== 'all' && type !== filter);
          });

          if (track) track.scrollTo({ left: 0, behavior: 'smooth' });
        });
      });

      openButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          openModal(button.getAttribute('data-iyi-ux-open'));
        });

        button.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          openModal(button.getAttribute('data-iyi-ux-open'));
        });
      });

      if (closeButton) closeButton.addEventListener('click', closeModal);
      if (prevButton) prevButton.addEventListener('click', function () { goToModalSlide(-1); });
      if (nextButton) nextButton.addEventListener('click', function () { goToModalSlide(1); });

      if (modal) {
        modal.addEventListener('click', function (event) {
          if (event.target === modal) closeModal();
        });
      }

      if (modalTrack) {
        modalTrack.addEventListener('click', function (event) {
          if (
            event.target === modalTrack ||
            event.target.classList.contains('iyi-user-experience-media__modal-slide')
          ) {
            closeModal();
          }
        });

        modalTrack.addEventListener('scroll', function () {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(playNearestVideo, 120);
        }, { passive: true });

        modalTrack.addEventListener('touchstart', function (event) {
          if (!event.touches || !event.touches.length) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          isHorizontalSwipe = false;
        }, { passive: true });

        modalTrack.addEventListener('touchmove', function (event) {
          if (!event.touches || !event.touches.length) return;
          var deltaX = event.touches[0].clientX - touchStartX;
          var deltaY = event.touches[0].clientY - touchStartY;

          if (Math.abs(deltaX) > 22 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
            isHorizontalSwipe = true;
            event.preventDefault();
          }
        }, { passive: false });

        modalTrack.addEventListener('touchend', function (event) {
          if (!event.changedTouches || !event.changedTouches.length) return;
          var deltaX = event.changedTouches[0].clientX - touchStartX;
          var deltaY = event.changedTouches[0].clientY - touchStartY;

          if (isHorizontalSwipe && Math.abs(deltaX) > 76 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
            closeModal();
          }
        }, { passive: true });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
      });

      window.addEventListener('popstate', function () {
        if (modal && !modal.hidden) closeModal(true);
      });
    });
  }

  function init(root) {
    initHero(root);
    initVariantPricing(root);
    initPackageOptions(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-iyi-product-root]').forEach(init);
    initInfoTabs(document);
    initResearchTabs(document);
    initUxTabs(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-iyi-product-root]');
    if (root) init(root);
    initInfoTabs(event.target);
    initResearchTabs(event.target);
    initUxTabs(event.target);
  });
})();
